<template>
    <b-modal hide-footer size="xl" id="allUsersModal" title="All Users">
        <b-overlay v-if="!hasMounted" :show="!hasMounted">
            <div style="height: 100px;"></div>
        </b-overlay>
        <div v-if="hasMounted">
            <webix-ui :config="config" v-model="users"></webix-ui>
        </div>
    </b-modal>
</template>

<script>
/* eslint-disable-next-line */
import _ from 'lodash'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        hasMounted: false,
        config:{
            id: 'allusersTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'id', header:'', hidden: true},
                { id: 'name', header:'Name', fillspace: true},
                { id: 'email', header:'Email', fillspace: 0.7},
                { id: 'work_qualifications', header:'Qualifications', fillspace: 0.5},
                { id: 'years_experience', header:'Experience', fillspace: 0.5},
                { id: 'designation', header:'Email', fillspace: 0.5},
                { id: 'in_level', header:'Is In Level', fillspace: 0.5, template:function(obj){
                    if(obj.in_level == true){
                        return '<i class="isInLevel fas fa-user-check" title="Click to remove user from level"></i>'
                    }
                    else{
                        return '<i class="notInLevel fas fa-user-plus" title="Click to add user from level"></i>'
                    }
                }},
                { id: 'actions', header:'Actions', fillspace: 0.5, template:function(obj){
                    console.log(obj);
                }},
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    /*var el = this.$scope.$parent;
                    setTimeout(()=>{
                        if(el.clickedAction == false){
                            el.selectRow(id.row);
                        }
                    }, 50)
                    */
                }
            },
            onClick:{
                //eslint-disable-next-line
                isInLevel(event, cell, target){
                    //! multiple use of $parent is probably because component is wraped in the boostrap tabs component */
                    var el = this.$scope.$parent.$parent.$parent;
                    el.removeUserFromLevel(cell);
                    
                },
                //eslint-disable-next-line
                notInLevel(event, cell, target){
                    //! multiple use of $parent is probably because component is wraped in the boostrap tabs component */
                    var el = this.$scope.$parent.$parent.$parent;
                    el.addUserToLevel(cell);
                },
            }
        },
    }),
    computed:{
        ...clientAdminState,
        hasUsers(){
            if(this.all_users == null){
                return false;
            }
            else if(this.all_users.length > 0){
                return true;
            }
            else{
                return false;
            }
        },
        users(){
            if(this.hasUsers){
                let users_obj = _.cloneDeep(this.all_users);
                this.users_in_level.forEach((item)=>{
                    let index = _.findIndex(users_obj, {id: item.id});
                    if(index != -1){
                        users_obj[index]['in_level'] = true;
                    }
                })
                return users_obj;
            }
            else{
                return [];
            }
        }
    },
    methods:{
        ...clientAdminMethods,
        addUserToLevel(id){
            let params = {
                level_id: Number(this.level_id),
                user_id: id.row,
            }
            this.addUserToSelectedLevel(params)
            .then(()=>{
                this.update();
            })
            .catch(()=>{
                alert('error');
            })
        },
        removeUserFromLevel(id){
            let params = {
                level_id: Number(this.level_id),
                user_id: id.row,
            }
            this.removeUserFromSelectedLevel(params)
            .then(()=>{
                this.update();
            })
            .catch(()=>{
                alert('error');
            })
        },
        update(){
            this.loadLevelUsers(0);
            this.loadLevelUsers(Number(this.level_id));
        }
    },
    mounted(){
        setTimeout(()=>{
            this.hasMounted = true;
            this.$nextTick(()=>{
                /*eslint-disable-next-line*/
                /*let table = $$('allusersTable');
                if(table != undefined){
                    table.refresh();
                }*/
            })
        }, 500);
        
    },
}
</script>

<style>
.isInLevel{
    cursor: pointer;
    color: limegreen;
}
.notInLevel{
    cursor: pointer;
    color: red;
}
</style>